"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiLinearProgress = void 0;
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var palette_1 = require("../../../theme/global/palette");
exports.MuiLinearProgress = (0, createStyles_1.default)({
    colorPrimary: {
        backgroundColor: palette_1.palette.info.contrastText,
        borderRadius: '2px',
    },
    barColorPrimary: {
        backgroundColor: palette_1.palette.primary.main,
        borderRadius: '2px',
    },
});
